import React from "react";
import Loader from "../components/global/loader.js";

export default function Index(props) {
    return <Loader classes="absolute top-5 left-1/2" />;
}
